import { DEFAULT_LOCALE } from 'constants/app-config'

export const createNamespaceLoader = (i18n, namespaceLoaders) => {
  const loadedNamespaces = new Map()

  const markNamespaceLoaded = (locale, namespace) => {
    const localeSet = loadedNamespaces.get(locale) || new Set()
    localeSet.add(namespace)
    loadedNamespaces.set(locale, localeSet)
  }

  const isNamespaceLoaded = (locale, namespace) => loadedNamespaces.get(locale)?.has(namespace)

  const loadI18nNamespaces = async (locale, namespaces, { emit = true } = {}) => {
    const loaders = namespaceLoaders[locale] || namespaceLoaders[DEFAULT_LOCALE]
    let hasNewNamespaces = false

    await Promise.all(
      namespaces.map(async (namespace) => {
        if (isNamespaceLoaded(locale, namespace)) {
          return
        }

        const loader = loaders[namespace]
        if (!loader) {
          return
        }

        const namespaceModule = await loader()
        i18n.addResourceBundle(locale, namespace, namespaceModule.default || namespaceModule, true, true)
        markNamespaceLoaded(locale, namespace)
        hasNewNamespaces = true
      }),
    )

    if (hasNewNamespaces && emit) {
      i18n.emit('languageChanged', i18n.resolvedLanguage || i18n.language)
    }
  }

  return loadI18nNamespaces
}
